import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-lg-8 mx-auto overflow-x-hidden" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "px-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_workflow_navigation = _resolveComponent("workflow-navigation")!
  const _component_help = _resolveComponent("help")!
  const _component_assets = _resolveComponent("assets")!
  const _component_page_nav = _resolveComponent("page-nav")!
  const _component_contact_us = _resolveComponent("contact-us")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("header", _hoisted_2, [
        _createVNode(_component_workflow_navigation, { workflowStage: "Haves" }),
        _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "skin-page-heading" }, " What you have to put towards retirement ", -1)),
        _createElementVNode("p", _hoisted_3, [
          _createTextVNode(_toDisplayString(_ctx.subHeadingText) + " ", 1),
          _createVNode(_component_help, {
            title: "What different parts can you put towards your retirement income?",
            text: _ctx.htmlArray('haves.help'),
            isWide: true
          }, null, 8, ["text"])
        ])
      ]),
      _createVNode(_component_assets),
      _createVNode(_component_page_nav, {
        backLink: "requirements",
        onNextClicked: _ctx.onNextClicked,
        "parent-will-handle-next": true,
        "next-link": _ctx.nextLink
      }, null, 8, ["onNextClicked", "next-link"]),
      _createVNode(_component_contact_us, { class: "mt-5" })
    ]),
    _createVNode(_component_modal, {
      ref: "noPotsModal",
      idKey: "NoPensionsWarning",
      title: "No pension pots added"
    }, {
      default: _withCtx(() => _cache[1] || (_cache[1] = [
        _createElementVNode("p", null, " We can show you how to take money from your pension pots along with everything else to get what you want, we would expect you would want to add at least one? ", -1)
      ])),
      _: 1
    }, 512)
  ], 64))
}